"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var media_1 = require("../../../theme/media");
var ALIGN = {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
};
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    display: flex;\n    align-items: ", ";\n    flex-wrap: ", ";\n\n    > * {\n      margin-right: ", "px;\n\n      &:last-child {\n        margin-right: 0;\n      }\n\n      @media ", " {\n        margin-right: ", "px;\n      }\n\n      @media ", " {\n        margin-right: ", "px;\n      }\n    }\n  }\n"], ["\n  && {\n    display: flex;\n    align-items: ", ";\n    flex-wrap: ", ";\n\n    > * {\n      margin-right: ", "px;\n\n      &:last-child {\n        margin-right: 0;\n      }\n\n      @media ", " {\n        margin-right: ", "px;\n      }\n\n      @media ", " {\n        margin-right: ", "px;\n      }\n    }\n  }\n"])), function (_a) {
    var $align = _a.$align;
    return ALIGN[$align];
}, function (_a) {
    var $wrap = _a.$wrap;
    return ($wrap ? 'wrap' : '');
}, function (_a) {
    var $amount = _a.$amount;
    return $amount.small;
}, media_1.breakpoints.medium, function (_a) {
    var $amount = _a.$amount;
    return $amount.medium;
}, media_1.breakpoints.large, function (_a) {
    var $amount = _a.$amount;
    return $amount.large;
});
var templateObject_1;
